import { useState } from 'react';
import { Link } from 'react-router-dom';
import { KeyRound, Copy, Check, ShieldCheck } from 'lucide-react';

export const OrderTagCodes = ({ tags, delivered }) => (
  <div className="mt-3 pt-3 border-t space-y-2" data-testid="order-tag-codes">
    <p className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold flex items-center gap-1"><KeyRound size={11} /> Emergency QR tags</p>
    {tags.map((t) => <TagCodeRow key={t.tag_id} t={t} delivered={delivered} />)}
  </div>
);

const TagCodeRow = ({ t, delivered }) => {
  const [copied, setCopied] = useState(false);
  const copy = () => { navigator.clipboard?.writeText(t.activation_code); setCopied(true); setTimeout(() => setCopied(false), 1500); };
  const active = t.status === 'active';
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap rounded-xl bg-navy/5 px-3 py-2" data-testid={`order-tag-${t.tag_id}`}>
      <span className="font-mono text-sm font-semibold">{t.tag_id}</span>
      {active ? (
        <span className="text-[11px] font-semibold text-green-700 flex items-center gap-1" data-testid={`order-tag-active-${t.tag_id}`}><ShieldCheck size={12} /> Activated</span>
      ) : t.activation_code ? (
        <div className="flex items-center gap-2">
          <span className="text-[11px] text-neutral-500">Code</span>
          <span className="font-mono font-bold tracking-widest text-navy" data-testid={`order-tag-code-${t.tag_id}`}>{t.activation_code}</span>
          <button onClick={copy} className="p-1 rounded hover:bg-navy/10" aria-label="Copy code" data-testid={`order-tag-copy-${t.tag_id}`}>{copied ? <Check size={13} /> : <Copy size={13} />}</button>
          <Link to={`/activate?tag=${t.tag_id}&code=${t.activation_code}`} className="btn-primary text-xs !py-1 !px-3" data-testid={`order-tag-activate-${t.tag_id}`}>Activate</Link>
        </div>
      ) : (
        <span className="text-[11px] text-neutral-500" data-testid={`order-tag-pending-${t.tag_id}`}>{delivered ? 'Code included in your tag pack' : 'Activation code appears after delivery'}</span>
      )}
    </div>
  );
};
